/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import TextField from '@mui/material/TextField';
import PaperOnCenter from '../PaperOnCenter';

export function usePasswordInputs() {
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [error, setError] = React.useState('');
  return {
    newPassword,
    confirmPassword,
    error,
    onChangeNewPassword: React.useCallback(
      (e) => setNewPassword(e.target.value),
      []
    ),
    onChangeConfirmPassword: React.useCallback(
      (e) => setConfirmPassword(e.target.value),
      []
    ),
    validate: () => {
      setError('');
      const res =
        newPassword === '' ||
        confirmPassword === '' ||
        newPassword === confirmPassword;
      if (!res) {
        setError('Password and Confirm password fields are not the same');
        return res;
      }
      if (newPassword.length < 6) {
        setError('Your password must be at least 6 characters long');
        return false;
      }
      return true;
    },
  };
}

export function NewPasswordInputs({
  newPasswordLabel,
  newPassword,
  confirmPassword,
  onChangeNewPassword,
  onChangeConfirmPassword,
  error,
}) {
  return (
    <>
      <PasswordInput
        name={newPasswordLabel}
        autoComplete="new-password"
        value={newPassword}
        onChange={onChangeNewPassword}
      />
      <PasswordInput
        name="Confirm password"
        autoComplete="new-password"
        value={confirmPassword}
        onChange={onChangeConfirmPassword}
        error={Boolean(error)}
        helperText={error}
      />
    </>
  );
}

export const PasswordInput = React.forwardRef(function PasswordInput(
  { name = 'Password', ...textFieldsProps },
  ref
) {
  return (
    <TextField
      inputRef={ref}
      data-cy={`${name}-input`}
      margin="normal"
      required
      fullWidth
      name="password"
      label={name}
      type="password"
      id={name}
      {...textFieldsProps}
    />
  );
});

export const EmailInput = React.forwardRef(function EmailInput(
  { id = 'email', ...textFieldProps },
  ref
) {
  return (
    <TextField
      inputRef={ref}
      data-cy="email-input"
      margin="normal"
      required
      fullWidth
      id={id}
      type="email"
      label="Email Address"
      name="username"
      autoComplete="email"
      autoFocus
      {...textFieldProps}
    />
  );
});

export default PaperOnCenter;
